// extracted by css-extract-rspack-plugin
export default {"root":"root-tGS2e0","panel":"panel-fSoCZl","item":"item-E_dGA1","active":"active-Kk8iwr","body":"body-vVoz7J","head":"head-RKhMwH","bodyInner":"bodyInner-o6b23P"};